import { mapRoadWorksMiddleware } from "./MapRoadWorksMiddleware";
import { mapWaysideLandLotsMiddleware } from "./MapWaysideLandLotsMiddleware";

export const mapsMiddleware: any = [
    mapWaysideLandLotsMiddleware,
    mapRoadWorksMiddleware
]
